module.exports = __webpack_public_path__ + "static/media/mobile.3ca043f0.svg";